import React, {useState} from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Snackbar,
  Stack,
  TextField
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {Close, PersonAdd, PersonAddAlt1} from "@mui/icons-material";
import axios from "axios";
import MenuItem from "@mui/material/MenuItem";
import {some} from "lodash";
import {Alert} from "@mui/lab";
import {USER_ROLES} from "../../stores/AuthStore";
import {sxTextField} from "../dashboard_view/UserDetails";
import TourService from "../../services/tour.service";

const AddTourManagerDialog = ({refetch}) => {
  const [error, setError] = useState(false)
  const [isValidEmail, setIsValidEmail] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [memberData, setMemberData] = useState({
    email: '',
    password: '',
    displayName: '',
    role: USER_ROLES.AGENCY.type
  })

  const handleToggleDialog = () => {
    setMemberData({
      email: '',
      displayName: '',
      password: '',
      role: USER_ROLES.AGENCY.type
    })
    setError(null)
    setOpenDialog(!openDialog)
  }

  const handleChange = (event) => {
    const fieldId = event.target.id || event.target.name
    if (fieldId === 'email') {
      setIsValidEmail(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,20})+$/.test(event.target.value))
    }

    setMemberData({...memberData, [fieldId]: event.target.value});
  };

  const handleAddMember = () => {
    axios({
      url: `${TourService.allTourManagersUrl()}`,
      method: 'POST',
      data: {...memberData, email: memberData.email.trim().toLowerCase(), role: memberData.role},
    })
      .then((res) => {
        if (res) {
          refetch().then(() => {
              handleToggleDialog()
          })
        }
      })
      .catch((err) => {
        setError(err.response?.data?.error || "Inserimento non andato a buon fine")
        console.log("handleSubmit new user --> err:", err)
      })
  }

  function handleCloseError() {
    setError(null)
  }

  return (
    <Stack>
      <Snackbar open={!!error} autoHideDuration={6000} onClose={handleCloseError}>
        <Alert elevation={6} variant={"filled"} onClose={handleCloseError} severity="error"
               sx={{width: '100%'}}>
          {error}
        </Alert>
      </Snackbar>
      <Box display={'flex'} alignItems={'center'} margin={'auto'}>
        {<IconButton
          onClick={handleToggleDialog}
          children={<PersonAddAlt1/>}
        />}
      </Box>
      <Dialog open={openDialog}>
        <DialogContent>
          <DialogContentText variant={'h5'} fontWeight={'bold'}>
            <Box display={'flex'}>
              Aggiungi nuovo tour manager
              <IconButton onClick={handleToggleDialog}
                          children={<Close/>}
                          sx={{ml: 'auto'}}
              />
            </Box>
          </DialogContentText>
          <TextField
            sx={sxTextField}
            autoFocus
            margin="dense"
            id="displayName"
            label="Nome"
            type="text"
            fullWidth
            variant="standard"
            required
            value={memberData.nome}
            onChange={handleChange}
          />
          <TextField
            sx={sxTextField}
            select
            autoFocus
            margin="dense"
            id="role"
            name="role"
            label="Ruolo"
            type="text"
            fullWidth
            variant="standard"
            required
            value={memberData.role}
            onChange={handleChange}
          >
            {Object.entries(USER_ROLES).map(([key, value]) => (
              <MenuItem key={key} value={key}>
                {value.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            sx={sxTextField}
            autoFocus
            margin="dense"
            id="email"
            label="E-mail"
            type="email"
            fullWidth
            variant="standard"
            required
            value={memberData.email}
            onChange={handleChange}
            error={!isValidEmail}
            helperText={"L'e-mail deve essere valida"}
          />
          <TextField
            sx={sxTextField}
            autoFocus
            margin="dense"
            id="password"
            label="Password"
            type="text"
            fullWidth
            variant="standard"
            required
            value={memberData.password}
            onChange={handleChange}
            error={memberData.password.length < 6}
            helperText={"Minimo 6 caratteri"}
          />
        </DialogContent>
        <DialogActions>
          <Button color={'secondary'} onClick={handleToggleDialog}>Annulla</Button>
          <Button variant={'submit-accent'} startIcon={<PersonAdd/>}
                  disabled={!isValidEmail || (some(Object.values(memberData), function (o) {
                    return !o
                  }))}
                  onClick={handleAddMember}>
            Aggiungi
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  )
}

export default AddTourManagerDialog